import React from 'react'

/**
 * A single track shared by 2+ identity segments (e.g. database vs storage
 * both counting against one combined quota), instead of one bar per
 * resource. Segments render in a fixed left-to-right order with a 2px
 * surface gap between them so each fill stays legible against its
 * neighbor; the untouched remainder of `total` is just the neutral track
 * showing through.
 */
const StackedUsageBar = ({ segments, total, heightClass = 'h-1.5' }) => {
  const used = segments.reduce((sum, seg) => sum + Math.max(seg.value, 0), 0)
  const usedWidthPct = total > 0 ? Math.min((used / total) * 100, 100) : 0
  const visibleWidthPct = used > 0 ? Math.max(usedWidthPct, 1.5) : 0

  return (
    <div className={`w-full ${heightClass} rounded-full overflow-hidden bg-gray-200 dark:bg-gray-700`}>
      <div className="h-full flex gap-[2px]" style={{ width: `${visibleWidthPct}%` }}>
        {segments.filter((seg) => seg.value > 0).map((seg, index) => (
          <div
            key={index}
            className={`h-full ${seg.colorClass} transition-all duration-500`}
            style={{ width: `${(seg.value / used) * 100}%` }}
          />
        ))}
      </div>
    </div>
  )
}

export default StackedUsageBar
